/**
 * Format a date to DD-MMM-YYYY format (e.g., 12-Nov-2025)
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
    if (!dateString) return '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) return '';
    
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${String(day).padStart(2, '0')}-${month}-${year}`;
};

/**
 * Format a date to DD-MMM-YYYY HH:MM format (e.g., 12-Nov-2025 14:30)
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date and time string
 */
export const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) return '';
    
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${String(day).padStart(2, '0')}-${month}-${year} ${hours}:${minutes}`;
};

/**
 * Format a date to DD-MMM-YYYY HH:MM:SS format (e.g., 12-Nov-2025 14:30:45)
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date and time string with seconds
 */
export const formatDateTimeWithSeconds = (dateString) => {
    if (!dateString) return '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) return '';
    
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${String(day).padStart(2, '0')}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
